// extracted by mini-css-extract-plugin
export default {"container":"dn-z","bubbleNav":"en-z","graphic":"fn-z","contact":"gn-z"};